import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import WorkshopBudgetForms from './mechanicalworkshopbudget-form.js'
import WorkshopBudgetModel from '@/shared/models/configuration/workshopbudgetmodel'
import WorkshopBudgetRepository from '@/shared/http/repositories/configuration/workshopbudget'

export default {
  name: 'MechanicalWorkshopBudget',
  mixins: [
    ActionsForm
  ],
  data () {
    return {
      data: WorkshopBudgetModel,
      form: WorkshopBudgetForms,
      workshopid: null
    }
  },
  methods: {
    onLoad () {
      if (this.workshopid) {
        loading.push()
        WorkshopBudgetRepository.GetAllPaging(this.workshopid, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch(this.onException)
      }
    },
    onCreate () {
      if (this.workshopid) {
        loading.push()
        this.data.mechanicalWorkshopID = this.workshopid
        this.data.companyID = '00000000-0000-0000-0000-000000000000'
        console.log(this.data)
        WorkshopBudgetRepository.Create(this.data)
          .then(this.onResult)
          .catch(this.onException)
      } else {
        toast.error('Você precisa selecionar uma oficina!')
      }
    },
    onUpdate () {
      if (this.workshopid) {
        loading.push()
        this.data.mechanicalWorkshopID = this.workshopid
        this.data.companyID = '00000000-0000-0000-0000-000000000000'
        WorkshopBudgetRepository.Update(this.data)
          .then(this.onResult)
          .catch(this.onException)
      } else {
        toast.error('Você precisa selecionar uma oficina!')
      }
    },
    onDelete (obj) {
      if (this.workshopid) {
        loading.push()
        WorkshopBudgetRepository.Delete(obj.id)
          .then((response) => {
            this.onResult(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        toast.error('Você precisa selecionar uma oficina!')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/mechanicalworkshop/budget/mechanicalworkshopbudget.js